import { SchemaModel } from '../../../../models/schemaModel';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import { selectAllSmscByCommitId } from '../../../../store/smsc/smscSelector';
import EsmeApi from '../../../../api/esmeApi';
import { fetchSchemaByName } from '../../../../store/schemas/schemasActions';
import { LogLevel } from '../../../../types/logLevel';
import { EsmeBindMode } from '../../../../models/esmeModel';
import EsmeForm, { EsmeDataForm } from '../../components/esme/EsmeForm';
import { AppErrorList, useAppErrorList } from '../../../../shared/components/AppErrorList';

type Props = {
  readonly schema: SchemaModel;
  readonly hideEsmeForm: () => void;
};

const EsmeAddFormContainer = (props: Props) => {
  const { schema, hideEsmeForm } = props;
  
  const dispatch = useAppDispatch();
  const [{ errors, hasErrors }, { addError, removeError }] = useAppErrorList();

  const smscIdList = useAppSelector(state => selectAllSmscByCommitId(state, schema.headCommitId))
    .map(smsc => smsc.object)
    .map(smscObject => smscObject.smscId);

  const handleAddEsme = (esme: any) => {
    const schemaName = schema.name;

    EsmeApi.addEsme(schemaName, esme)
      .then(() => {
        dispatch(fetchSchemaByName(schemaName));
        hideEsmeForm();
      })
      .catch(addError);
  };

  const initialValues = {
    user: {
      logLevel: LogLevel.DEBUG,
      maxBinds: 5,
      bindModes: [EsmeBindMode.TRANSCEIVER],
      sessionTimeout: 120,
      throughput: 20,
    },
  } as EsmeDataForm;

  return (
    <>
      { hasErrors && (
        <AppErrorList
          errors={errors}
          onCloseError={removeError}
        />
      )}

      <EsmeForm
        title='Add esme'
        smscIdList={smscIdList}
        initialValues={initialValues}
        onSubmit={handleAddEsme}
        onCancel={hideEsmeForm}
        readOnly={false}
      />
    </>
  );
};

export default EsmeAddFormContainer;
